export default __webpack_public_path__ + "static/media/usdxxEarnArt.ccff2c8a.png";